import { Avatar, AvatarGroup } from "@mantine/core"
import type { TUser } from "@/types"
import { UserAvatar } from "./UserAvatar"

export function UsersAvatarGroup({
  users,
  limit = 3,
  ...props
}: { users: TUser[]; limit?: number } & Omit<Parameters<typeof UserAvatar>[0], "user">) {
  if (!users || users.length === 0) return null
  return (
    <AvatarGroup>
      {users.slice(0, limit).map((user) => (
        <UserAvatar key={user.id} user={user} {...props} />
      ))}
      {users.length > limit && <Avatar {...props}>+{users.length - limit}</Avatar>}
    </AvatarGroup>
  )
}
